import { ItemDetails } from "./../../_models/item/item-details.model";
import utils from './../../utils';
import { CustomerDetails } from "../customer/customer-details.model";
import { CustomerCredit } from "../customer/customer-credit.model";

import { BookingBookModel } from "../booking/booking-book.model";
import { BookingPrepayModel } from "../booking/booking-prepay.model";
import { BookingQuoteModel } from "./booking-quote.model";
import { SalesOrder } from "../order/sales-order.model";
import { ApproveBookingRequest } from "./ApproveBookingRequest";

export class BookingRequest {
    agentId: string;
    tenantId: string;
    user: any;
    bookingId: number | null;
    totalBookingAmount: number;
    nameId: string;
    location: string;
    startDate: Date;
    endDate: Date;
    bookingItems: ItemDetails[];
    customerInfo: CustomerDetails;
    billToCustomer: CustomerDetails;
    creditInfo: CustomerCredit;
    bookingBook: BookingBookModel;
    bookingNumber :string ;
    bookingPrepay: BookingPrepayModel;
    bookingQuote: BookingQuoteModel;
    salesOrder: SalesOrder;
    isByPhone: boolean;
    expiryDate: Date;
    ApproveRequest: number;
    bankCode: string;
    approveBookingRequest: ApproveBookingRequest;
    toEmails:string;
    pendingAgreementConfig:boolean = false;
    isAutoApprove:boolean;
    isQuoteConverted:boolean;
    isAlert :boolean;
    userBookingDate :Date;
    farm:string;
    farmName:string;
    field:string;
    fieldName:string;
    clientId: string;
    dataSource:any;
    remarksNumberForBookingProgram:any;
    remarksNumberForFarmAndField:any;
    totalPrice: any;
    customerDescription: any;
    customerId: any;
    
    constructor() {
        this.bookingId = null;
        this.totalBookingAmount = 0;
        this.nameId = '';
        this.location = utils.getLocation();
        this.startDate = new Date();
        this.endDate = new Date();
        this.bookingItems = [];
        this.bookingNumber='';
        this.customerInfo = new CustomerDetails;
        this.billToCustomer = new CustomerDetails;
        this.creditInfo = new CustomerCredit;
        this.bookingBook = new BookingBookModel;
        this.bookingQuote = new BookingQuoteModel;
        this.salesOrder = new SalesOrder
        this.bookingPrepay = new BookingPrepayModel;
        this.isByPhone = false;
        this.expiryDate = new Date();
        this.ApproveRequest = 0;
        this.bankCode = ''
        this.approveBookingRequest = new ApproveBookingRequest;
        this.isAutoApprove = false;
        this.isQuoteConverted = false;
        this.isAlert = false;
        this.userBookingDate =new Date();
        
    }

}
export class SplitBookingRequest {
    bookings: BookingRequest[];
}
